module.exports = __webpack_public_path__ + "img/00bc14630dac5f85fa05aef16702ecef.png";


//////////////////
// WEBPACK FOOTER
// ./classes/items/eggs/assets/sprites/eggs.png
// module id = 68
// module chunks = 0